import type React from 'react';
import { Section, SectionHeader } from '@/components/ui/Section';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';
import { WavyDivider } from '@/components/ui/decorative';

export const FAQ: React.FC = () => {
  const faqs = [
    {
      question: 'Will it sound like generic AI?',
      answer: 'No. We use custom style guides combined with citation-backed research to ensure output reflects your unique voice and expertise, not generic AI-speak.'
    },
    {
      question: 'What if I don\'t use it monthly?',
      answer: 'That\'s exactly why we don\'t charge a subscription. You buy credits for articles when you need them. They remain active in your account until used or until expiration of bulk packs.'
    },
    {
      question: 'What\'s included in each article?',
      answer: 'Each credit includes the full workflow: automated deep research, outline generation, source validation, drafting, editing, and export to Markdown or Word.'
    },
    {
      question: 'Is my data private?',
      answer: 'Yes. Your research inputs and generated drafts are private to your account. We do not use your personal data to train our public models.'
    },
    {
      question: 'Can I edit the generated content?',
      answer: 'Absolutely. You have full control to edit any section, regenerate specific parts, or refine the entire article. Auto-save ensures you never lose your work.'
    }
  ];

  return (
    <Section className="bg-cream-paper">
      <SectionHeader
        badge="FAQ"
        title="Questions? We've got answers."
        description="Everything you need to know before starting."
      />

      <div className="max-w-3xl mx-auto">
        <div className="mb-12 flex justify-center">
          <WavyDivider className="w-full max-w-md" />
        </div>

        <Accordion type="single" collapsible className="w-full">
          {faqs.map((faq) => (
            <AccordionItem key={faq.question} value={faq.question} className="border-b border-aged-brass/20 last:border-0">
              <AccordionTrigger className="text-lg md:text-xl font-display font-bold text-charcoal text-left hover:text-bottle-green transition-colors py-6">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-base text-muted-warm leading-relaxed font-normal bg-pressed-paper/50 py-6">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>

        <div className="mt-12 text-center">
          <p className="text-muted-warm text-base mb-6">Still have questions?</p>
          <button
            type="button"
            onClick={() => globalThis.location.href = 'mailto:support@vantagedraft.com'}
            className="text-base font-medium text-bottle-green hover:text-aged-brass transition-colors underline decoration-aged-brass/30 hover:decoration-aged-brass underline-offset-4"
          >
            Contact Support
          </button>
        </div>
      </div>
    </Section>
  );
};
